import { useTranslation } from 'react-i18next';

export default function ClashRoundHeader({
  styles,
  duelNumber,
  maxDuels,
  isDecisive,
}) {
  const { t } = useTranslation('zodiacClash');
  const safeDuelNumber = Math.min(Math.max(Number(duelNumber) || 1, 1), maxDuels);
  const progress = (safeDuelNumber / maxDuels) * 100;

  return (
    <div
      className={`zdxRoundHeader${isDecisive ? ' zdxRoundHeaderDecisive' : ''}`}
      style={{
        ...styles.roundHeader,
        ...(isDecisive ? styles.roundHeaderDecisive : {}),
      }}
      aria-label={
        isDecisive
          ? t('decisiveDuelLabel', { current: safeDuelNumber, total: maxDuels })
          : t('duelLabel', { current: safeDuelNumber, total: maxDuels })
      }
    >
      <div style={styles.roundHeaderTop}>
        <span style={styles.roundEyebrow}>
          {isDecisive ? t('decisiveDuel') : t('duel', { number: safeDuelNumber })}
        </span>

        <span style={styles.roundCounter}>
          {safeDuelNumber}/{maxDuels}
        </span>
      </div>

      <div style={styles.roundProgressTrack} aria-hidden="true">
        <div
          className="zdxRoundProgressFill"
          style={{
            ...styles.roundProgressFill,
            width: `${progress}%`,
          }}
        />
      </div>

      <div style={styles.roundHeaderHint}>
        {isDecisive
          ? t('finalChoice')
          : t('chooseBeforeCommunity')}
      </div>
    </div>
  );
}
